export const SIDEBAR_EXPANDED_W = 272;
export const SIDEBAR_COLLAPSED_W = 64;
export const MOBILE_W = 280;

export const SPRING = {
  type: "spring",
  stiffness: 280,
  damping: 28,
} as const;

/**
 * Space-switch slide. `custom` is the direction sign (1 LTR, -1 RTL) so the
 * list arrives from the start edge in both languages — pass it to the
 * `motion` element AND its `AnimatePresence`, or the exit stays physical.
 */
export const navListVariants = {
  hidden: (dir = 1) => ({ opacity: 0, x: -12 * dir }),
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.22, ease: "easeOut" as const },
  },
  exit: (dir = 1) => ({
    opacity: 0,
    x: -8 * dir,
    transition: { duration: 0.12, ease: "easeIn" as const },
  }),
};
